/**
 * Infrastructure category config
 *
 * KPIs: name (Infrastructure Name), quantity (Quantity)
 *
 * Special behaviour:
 *  - KPI dropdown replaced by multi-select of infrastructure items
 *  - Data pivoted: one row per school with infra_N columns
 *  - API always called with kpi=quantity
 */
import type { CategoryConfig, ChartDescriptor } from './CategoryConfig';
import { INFRA_KPI_OPTIONS, INFRA_COLUMN_LABEL_OVERRIDES } from '../utils/infraUtils';

export const infraProfileConfig: CategoryConfig = {
  categoryKey: 'infraProfile',
  label: 'Infrastructure',
  priority: 2,

  pivotData: true,

  kpi: {
    multiSelect: true,
    staticOptions: INFRA_KPI_OPTIONS,
    apiKpiKey: 'quantity',
  },

  columns: {
    defaultVisibleColumns: [
      'schoolName', 'stateName', 'roName', 'districtName',
    ],
    hideColumns: ['name', 'quantity'],
    labelOverrides: INFRA_COLUMN_LABEL_OVERRIDES,
  },

  chart: (kpi): ChartDescriptor | null => ({
    type: 'bar',
    title: (_, filtered) =>
      `Infrastructure Quantity Comparison${filtered ? ' (Filtered)' : ''}`,
    xAxisLabel: 'Infrastructure Type',
    yAxisLabel: 'Total Quantity',
    buildData: (ctx) => {
      const ids = ctx.selectedInfraItems.length > 0 ? ctx.selectedInfraItems : [];
      return ids
        .map(id => {
          const label =
            INFRA_KPI_OPTIONS.find(o => o.key === id)?.label || `Infra ${id}`;
          const total = ctx.infraPivotedSchools.reduce(
            (s, school) => s + Number(school[`infra_${id}`] || 0),
            0,
          );
          return { name: label, value: total, sortKey: Number(id) };
        })
        .sort((a, b) => a.sortKey - b.sortKey);
    },
  }),
};
